// Photo zoom for the BS26 sale-list page: tapping a bag photo shows it BIG (anh 11-02 insight: people tap a photo to see the
// bag larger — not to sign up, not to leave the page). One <dialog> per page: big photo · name · price line · B26 join
// (signup page only; 11-02 review: catch people while they look at a bag) · optional "See all styles" · ✕ / outside / Esc.
// Appended inside the section root so the brand CSS variables still apply.
// B26 join reuses the page's paths: one-tap (SLQ_ONETAP, SMS visitors) · TEXT B26 sms: link tracked by SLQ_ASK (mobile) ·
// desktop → closes and focuses the hero phone field. Never on REG.
(function () {
  const C = window.SLQ_CONFIG, T = window.SLQ_TRACK || { listAction() {} };
  const S = () => window.SLQ_STATE || {};
  const isMobile = () => window.matchMedia('(max-width: 899px)').matches;
  let dlg = null;

  function joinHtml() {
    const st = S(), kw = C.sms.keyword, one = window.SLQ_ONETAP && window.SLQ_ONETAP.on;
    if (st.isReg || (window.SLQ_PAGE && window.SLQ_PAGE.reg)) return '';
    if (st.onetapJoined) return '<p class="slq-zoom__joined">' + window.SLQ_ONETAP.doneHtml('zoom') + '</p>';
    if (one) return '<button class="slq-btn" data-onetap="zoom" data-hc-el="onetap-join-zoom">COUNT ME IN</button><p class="slq-zoom__note">Tap once to get the sale link.</p>';
    if (!isMobile()) return '<button class="slq-btn" data-zoom-phone data-hc-el="zoom-phone">Get the sale link</button>';
    const legal = (document.querySelector('[data-lp-join] .lp-legal') || {}).innerHTML || '';
    return `<a class="slq-btn" data-b26 data-ask-sms="zoom" data-hc-el="slq-b26-zoom" href="sms:${C.sms.number}?&body=${kw}">TEXT ${kw} TO JOIN</a>
      <p class="slq-zoom__note">${kw} is already typed. Just hit send.</p><p class="lp-legal slq-zoom__legal">${legal}</p>`;
  }
  const renderJoin = () => { if (dlg) dlg.querySelector('[data-zoom-join]').innerHTML = joinHtml(); };

  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'slq-zoom';
    dlg.setAttribute('aria-label', 'Bag photo');
    dlg.innerHTML = '<button class="slq-zoom__x" data-zoom-close aria-label="Close" data-hc-el="zoom-close">✕</button>' +
      '<img class="slq-zoom__img" alt="" width="560" height="560">' +
      '<div class="slq-zoom__cap"><strong></strong><span></span></div>' +
      '<div class="slq-zoom__join" data-zoom-join></div>' +
      '<button class="slq-ghost slq-zoom__more" data-zoom-more data-hc-el="zoom-more">See all styles</button>';
    (document.querySelector('.slqp') || document.body).appendChild(dlg);
    dlg.addEventListener('click', (e) => {
      if (e.target === dlg || e.target.closest('[data-zoom-close]')) close(); // backdrop tap lands on the dialog itself
      else if (e.target.closest('[data-zoom-more]')) { const more = dlg._more; close(); if (more) more(); }
      else if (e.target.closest('[data-zoom-phone]')) { // desktop: the hero phone field is the way in
        close(); T.listAction('zoom-phone');
        const t = document.getElementById('lp-tel'); if (t) { t.scrollIntoView({ block: 'center' }); t.focus({ preventScroll: true }); }
      }
      else if (e.target.closest('[data-b26]')) setTimeout(renderJoin, 450); // SLQ_ASK tracks the tap; Messages opens first
    });
  }
  function close() { if (dlg && dlg.open) { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); } }

  // o = { img, title, sub, where, onMore } — onMore given → "See all styles" button shown.
  function open(o) {
    if (!dlg) build();
    const img = dlg.querySelector('.slq-zoom__img');
    img.src = window.SLQ_LOGIC.cdnW(o.img, 900); img.alt = o.title;
    dlg.querySelector('.slq-zoom__cap strong').textContent = o.title;
    dlg.querySelector('.slq-zoom__cap span').textContent = o.sub || '';
    renderJoin();
    const more = dlg.querySelector('[data-zoom-more]'); more.hidden = !o.onMore; dlg._more = o.onMore || null;
    T.listAction('photo-zoom', (o.where || '') + ':' + o.title);
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  }

  // Price line shared by every caller: "Handbag · $28.59 with 4+ pieces".
  const priceLine = (p) => (p && p.p4 ? `${p.label || p.type} · $${p.p4.toFixed(2)} with 4+ pieces` : '');
  window.SLQ_ZOOM = { open, priceLine, refresh: renderJoin }; // refresh: one-tap result re-renders the join area
})();
